<a
  class="tag-item"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{exact:true}"
  [routerLink]="projectFilter.tagid > 0 ? [ projectFilter.tagid, projectFilter.slug] : ['/home']"
  (click)="onClickFilter()"
>
  {{ projectFilter.name }}
</a>
